import apiClient from './api';

const employeeService = {
  getEmployees: async (params) => {
    return apiClient.get('/employees/', { params });
  },

  getEmployee: async (id) => {
    return apiClient.get(`/employees/${id}`);
  },

  createEmployee: async (data) => {
    return apiClient.post('/employees/', data);
  },

  updateEmployee: async (id, data) => {
    return apiClient.put(`/employees/${id}`, data);
  },

  deleteEmployee: async (id) => {
    return apiClient.delete(`/employees/${id}`);
  },

  getAttendance: async (employeeId, params) => {
    return apiClient.get(`/employees/${employeeId}/attendance`, { params });
  },

  getLeaves: async (params) => {
    return apiClient.get('/employees/leaves', { params });
  },

  requestLeave: async (data) => {
    return apiClient.post('/employees/leaves', data);
  },

  updateLeave: async (id, data) => {
    if (data.status === 'approved') {
      return apiClient.put(`/employees/leaves/${id}/approve`);
    } else if (data.status === 'rejected') {
      return apiClient.put(`/employees/leaves/${id}/reject`);
    }
    throw new Error('Invalid leave status');
  },

  approveLeave: async (leaveId) => {
    return apiClient.put(`/employees/leaves/${leaveId}/approve`);
  },

  rejectLeave: async (leaveId) => {
    return apiClient.put(`/employees/leaves/${leaveId}/reject`);
  },
};

export default employeeService;
